export const getDocument = (): Document => document;
